/* section-header.js — Slice 3 Phase 2: trigger delegation + cart/wishlist live-update */
(function () {
  'use strict';
  window.theme = window.theme || {};
  if (window.theme.sectionHeaderBound) return;
  window.theme.sectionHeaderBound = true;

  function fmtMoney(cents) {
    if (window.theme.utilities && window.theme.utilities.formatMoney) return window.theme.utilities.formatMoney(cents);
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents, (window.theme && window.theme.moneyFormat) || '${{amount}}');
    return '$' + (cents / 100).toFixed(2);
  }

  function onClick(e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-mobile-menu-trigger]')) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('mobile-menu:open'));
      return;
    }
    if (e.target.closest('[data-open-search-drawer]')) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('search:open'));
      return;
    }
    var cartBtn = e.target.closest('[data-open-cart-drawer]');
    if (cartBtn) {
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:open'));
    }
  }

  function onInlineSubmit(e) {
    var form = e.target.closest && e.target.closest('[data-search-inline-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('[data-search-inline-input]');
    var query = input ? input.value.trim() : '';
    if (query) window.theme._pendingSearchQuery = query;
    document.dispatchEvent(new CustomEvent('search:open'));
  }

  function applyPendingQuery() {
    var query = window.theme._pendingSearchQuery;
    if (!query) return;
    var drawerInput = document.querySelector('[data-search-input]');
    if (!drawerInput) { requestAnimationFrame(applyPendingQuery); return; }
    drawerInput.value = query;
    drawerInput.dispatchEvent(new Event('input', { bubbles: true }));
    window.theme._pendingSearchQuery = null;
  }

  function onCartUpdated(e) {
    var cart = e.detail && e.detail.cart;
    if (!cart) return;
    var count = cart.item_count || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var btn = el.closest('[data-cart-trigger]'); if (!btn) return;
      var showZero = btn.getAttribute('data-cart-show-zero') === 'true';
      var inline = el.classList.contains('header-cart-trigger__count-inline');
      el.textContent = inline ? '(' + count + ')' : String(count);
      el.hidden = !(count > 0 || showZero);
    });
    document.querySelectorAll('[data-cart-price]').forEach(function (el) {
      var btn = el.closest('[data-cart-trigger]'); if (!btn) return;
      var showEmpty = btn.getAttribute('data-cart-show-price-when-empty') === 'true';
      el.textContent = fmtMoney(cart.total_price || 0);
      el.hidden = !(count > 0 || showEmpty);
    });
    document.querySelectorAll('.header-cart-trigger__pill-sep').forEach(function (el) {
      var btn = el.closest('[data-cart-trigger]'); if (!btn) return;
      var showZero = btn.getAttribute('data-cart-show-zero') === 'true';
      el.hidden = !(count > 0 || showZero);
    });
  }

  function setWishlistCount(count) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      var link = el.closest('[data-wishlist-trigger]');
      var showZero = link && link.getAttribute('data-wishlist-show-zero') === 'true';
      el.textContent = String(count);
      el.setAttribute('data-wishlist-count', String(count));
      el.hidden = !(count > 0 || showZero);
    });
  }

  function hydrateWishlist() {
    var c = 0;
    if (window.theme.wishlist && typeof window.theme.wishlist.getCount === 'function') c = window.theme.wishlist.getCount() || 0;
    setWishlistCount(c);
  }

  function onWishlistChanged(e) {
    var d = e.detail || {};
    setWishlistCount(typeof d.count === 'number' ? d.count : 0);
  }

  function bind() {
    document.addEventListener('click', onClick);
    document.addEventListener('submit', onInlineSubmit);
    document.addEventListener('cart:updated', onCartUpdated);
    document.addEventListener('search:open', applyPendingQuery);
    document.addEventListener('wishlist:changed', onWishlistChanged);
    hydrateWishlist();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
